import { toast } from "react-toastify";

export const handleErrors = (messages, isException = false) => {
    if (messages) {
        messages.forEach(element => {
            if (isException) {
                toast.error("Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.");
                console.log("[Exception]", element);
            }
            else {
                toast.error(decodeError(element));
                console.log("[Error]", element);
            }
        });
    }
}

const decodeError = (error) => {

    const msgErrorMessage = error.error_message ? `${error.error_message} ` : "";
    const msgErrorField = error.field_name ? ` [${error.field_name}]` : "";

    if (error.error_type === "PUBLIC_WEB_ERROR") {
        return `${msgErrorMessage}${msgErrorField}`;
    }

    if (error.error_type === "NOT_AUTHORIZED") {
        return "Não tens permissões para realizar esta operação.";
    }

    return `Erro desconhecido no serviço${msgErrorField}${msgErrorMessage}`;
}
